import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import PersonalDashboardGcsp from '../../components/templates/gcsp/dashboard/personalDashboardGcsp';
import YearlyMetricsGcsp from '../../components/templates/gcsp/dashboard/yearlyMetricsGcsp';
import QuarterDetailsGcsp from '../../components/templates/gcsp/dashboard/quarterlyDetailsGcsp';
import { device } from '../../util/commonMediaStylesUtil';
import DashboardAlerts from '../../components/organisms/alertBar/dashboardAlerts';
import SpinnerLoader from '../../components/atoms/SpinnerLoader';
import DateTimePicker from '../../components/atoms/datePicker/dateTimePicker';

let screenName = 'dashboard';

const DashboardWrapper = styled.div`
  background-color: #eaeaf2;
  min-height: 100vh;
`;

const CenteredSpinner = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const DashboardContainer = styled.div`
  padding: 30px;
  gap: 30px;
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: flex-start;
  max-width: 1600px;
  margin: 0 auto;

  ${device.tablet`
    padding: 30px 0px; 
 `}

  ${device.phone_md`
    padding: 20px 0px; 
  `}
`;

const DashboardTitles = styled.div`
  height: 17px;
  font-family: EYInterstate;
  font-size: 24px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: left;
  color: #000000;
  white-space: nowrap;

  ${device.laptop_sm`
    padding-left: 10px; 
 `}
`;

function GcspDashboard(props) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <DashboardWrapper>
        {loading && (
          <CenteredSpinner>
            <SpinnerLoader color="#155CB4" />
          </CenteredSpinner>
        )}
        <DashboardAlerts screenName={screenName} />
        <DashboardContainer>
          {!loading && (
            <>
              <DashboardTitles>
                My Dashboard
                <DateTimePicker />
              </DashboardTitles>
              <PersonalDashboardGcsp />
              <DashboardTitles>Yearly Metrics</DashboardTitles>
              <YearlyMetricsGcsp />
              <DashboardTitles>Quarterly/Monthly Metrics</DashboardTitles>
              <QuarterDetailsGcsp />
            </>
          )}
        </DashboardContainer>
      </DashboardWrapper>
    </>
  );
}

export default GcspDashboard;
